import React, { Component } from 'react';

class PatternLocksDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                By default, parameters remain the same between patterns.
                However, locking a pattern allows you to set different parameters,
                specific to that pattern-- without affecting other patterns.
              </p>
                
              <p>
                To lock a pattern, in a track, click the "lock" button,
                which looks like this.
              </p>
                <div>
                  <img
                    className="lock-button"
                    src="/closed-padlock.png"/>
                </div>
              <p>
                For example, if you are on pattern 5, and wish to 
                have a different Filter Cutoff Frequency than the
                other patterns, lock the pattern and then change the cutoff frequency. 
              </p>
              <p>
                LFOs and Envelopes can also be pattern locked, using the same process. 
              </p>
            </div>
        );
    }
}

export default PatternLocksDocumentation;
